import { createContext } from "react";

/**
 * Context to share App-level layout props (handleLogout, font controls, theme state, etc.)
 * with layout components (DefaultLayout, RewampLayout) without prop drilling through Route.js.
 */
export const AppLayoutContext = createContext();
